import Vue from 'vue'

import store from '@/store'
import router from '@/router'
import * as types from './mutation-types'


export const setAlreadyWalletConnected = function ({ commit }, result) {
  commit(types.SET_ALREADY_WALLET_CONNECTED, result)
}